import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name combine
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgM2ExIDEgMCAwIDEgMSAxdjVhMSAxIDAgMCAxLTEgMSIgLz4KICA8cGF0aCBkPSJNMTkgM2ExIDEgMCAwIDEgMSAxdjVhMSAxIDAgMCAxLTEgMSIgLz4KICA8cGF0aCBkPSJtNyAxNSAzIDMiIC8+CiAgPHBhdGggZD0ibTcgMjEgMy0zSDVhMiAyIDAgMCAxLTItMnYtMiIgLz4KICA8cmVjdCB4PSIxNCIgeT0iMTQiIHdpZHRoPSI3IiBoZWlnaHQ9IjciIHJ4PSIxIiAvPgogIDxyZWN0IHg9IjMiIHk9IjMiIHdpZHRoPSI3IiBoZWlnaHQ9IjciIHJ4PSIxIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/combine
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Combine: IconNode = [
  ['path', { d: 'M14 3a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1' }],
  ['path', { d: 'M19 3a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1' }],
  ['path', { d: 'm7 15 3 3' }],
  ['path', { d: 'm7 21 3-3H5a2 2 0 0 1-2-2v-2' }],
  ['rect', { x: '14', y: '14', width: '7', height: '7', rx: '1' }],
  ['rect', { x: '3', y: '3', width: '7', height: '7', rx: '1' }],
];

export default Combine;
